import React from 'react';
import { CircularProgress, Box, Typography, Grid } from '@mui/material';

const LoadingScreen = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#f0f4f8',
                padding: '40px',
            }}
        >
            {/* Circular Loader */}
            <CircularProgress
                sx={{
                    color: '#3f51b5',
                    marginBottom: '24px',
                }}
                size={80}
                thickness={4.5}
            />

            {/* Main Loading Text */}
            <Typography
                variant="h5"
                sx={{
                    fontFamily: "'Work Sans', sans-serif",
                    color: '#333',
                    fontWeight: 600,
                    letterSpacing: '0.8px',
                    marginBottom: '16px',
                }}
            >
                Please wait while we analyze the data...
            </Typography>

            {/* Subheading */}
            <Typography
                variant="body1"
                sx={{
                    fontFamily: "'Work Sans', sans-serif",
                    color: '#555',
                    textAlign: 'center',
                    maxWidth: '600px',
                    marginBottom: '40px',
                }}
            >
                Explore the most comprehensive stock insights, real-time market analysis, and expert-driven recommendations tailored to your investment strategy.
            </Typography>

            {/* Grid Section for Features */}
            <Grid
                container
                spacing={3}
                sx={{
                    maxWidth: '800px',
                    textAlign: 'center',
                }}
            >
                {/* Feature 1 */}
                <Grid item xs={12} sm={6}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontFamily: "'Work Sans', sans-serif",
                            fontWeight: 600,
                            color: '#3f51b5',
                            marginBottom: '8px',
                        }}
                    >
                        Real-Time Insights
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            fontFamily: "'Work Sans', sans-serif",
                            color: '#666',
                        }}
                    >
                        Get the latest stock market data as it happens.
                    </Typography>
                </Grid>

                {/* Feature 2 */}
                <Grid item xs={12} sm={6}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontFamily: "'Work Sans', sans-serif",
                            fontWeight: 600,
                            color: '#3f51b5',
                            marginBottom: '8px',
                        }}
                    >
                        Smart Recommendations
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            fontFamily: "'Work Sans', sans-serif",
                            color: '#666',
                        }}
                    >
                        Leverage AI-driven insights to guide your investments.
                    </Typography>
                </Grid>

                {/* Feature 3 */}
                <Grid item xs={12} sm={6}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontFamily: "'Work Sans', sans-serif",
                            fontWeight: 600,
                            color: '#3f51b5',
                            marginBottom: '8px',
                        }}
                    >
                        Customizable Filters
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            fontFamily: "'Work Sans', sans-serif",
                            color: '#666',
                        }}
                    >
                        Sort and filter stocks based on your specific needs.
                    </Typography>
                </Grid>

                {/* Feature 4 */}
                <Grid item xs={12} sm={6}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontFamily: "'Work Sans', sans-serif",
                            fontWeight: 600,
                            color: '#3f51b5',
                            marginBottom: '8px',
                        }}
                    >
                        Intuitive Interface
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            fontFamily: "'Work Sans', sans-serif",
                            color: '#666',
                        }}
                    >
                        Seamless user experience designed for efficiency.
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LoadingScreen;
